import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MaterialTable, { Column, MTableToolbar } from 'material-table';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AssignmentIcon from '@material-ui/icons/Assignment';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { RowDataRawOrder } from 'src/reducers/completeorderfile';
import Fab from '@material-ui/core/Fab';
import AutorenewIcon from '@material-ui/icons/Autorenew';
// import NoteAddOutlinedIcon from '@material-ui/icons/NoteAddOutlined';
import FilterListIcon from '@material-ui/icons/FilterList';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { 
    Tooltip, 
    withStyles, 
    MenuProps, 
    Menu, 
    Typography, 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    IconButton, 
    FormControl, 
    Select, 
    TextField, 
    Switch, 
    FormControlLabel, 
    Checkbox, 
    RadioGroup, 
    Radio,
    Box 
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { forwardRef } from 'react';
import { Icons } from 'material-table';
import DescriptionSharpIcon from '@material-ui/icons/DescriptionSharp';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CircularProgress from '@material-ui/core/CircularProgress';
import { CSVLink } from 'react-csv';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@material-ui/core';

interface TableState {
    columns: Array<Column<RowDataRawOrder>>;
    data: RowDataRawOrder[];
}

export interface OrderRawDataViewProps {
    orderrawdata: RowDataRawOrder[];
    orderrawdataExport: RowDataRawOrder[];
    reload: (fcaseno: string, tcaseno: string, timezone: string) => void;
    onRowClick: (orderid: string, rowData: string) => void;
    // onFileName:(fileName: string) => void;
    fDate: (fromDate: Date | null) => void;
    toDate: (todate: Date | null) => void;

    startDate: Date | null;
    endDate: Date | null;

    dateFilter: (fcaseno: string, tcaseno: string, timezone: string) => void;
    dateReset: (timezone: string) => void;

    isDownloading: boolean;
    // onBulkDownload: (completedData: RowDataRawOrder[] | RowDataRawOrder) => void;
    onBulkDownloadStl: (completedData: RowDataRawOrder[] | RowDataRawOrder, filetype: string) => void;
    // onBulkDownloadIndividual: (completedData: RowDataRawOrder[] | RowDataRawOrder) => void;
    onBulkDownload: (completedData: RowDataRawOrder[] | RowDataRawOrder, isRetry?: boolean) => void;
    onBulkDownloadIndividual: (completedData: RowDataRawOrder[] | RowDataRawOrder, isRetry?: boolean) => void;
    failedFiles: Array<{ fname: string; orderno: string; fileType?: string; caseCount?: number }>;
    showFailedFilesDialog: boolean;
    failedFilesMessage: string;
    closeFailedFilesDialog: () => void;
}

export const tableIcons: Icons = {
    Export: forwardRef((props, ref) => <DescriptionSharpIcon {...props} ref={ref} />)
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 800,
        },
        forms: {
            width: '15%', // Fix IE 11 issue.
        },
        buttonSend: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            margin: '5px',
            position: 'relative'
        },
        buttonSend2: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            margin: '13px',
            position: 'relative'
        },
        root1: {
            display: 'flex',
            height: '30vh'
        },
        fileUpload: {
            textAlign: 'center',
            fontSize: '18px',
            color: '#808080',
            height: '20vh',
            border: '2px solid #808080',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderStyle: 'dotted',
            '&:hover': {
                border: '4px solid #ff0000'
            }
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'center'
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        dialog: {
            margin: theme.spacing(2)
        },
        HeadinG: {
            margin: theme.spacing(1),
            '& .MuiInputBase-input': {
                fontSize: '0.9rem'
            },
            '& .MuiButton-label': {
                fontSize: '0.7rem'
            },
            fontSize: '0.9rem'
        },
        mtable: {
            '& .MuiButton-root': {
                fontSize: '12px',
                textTransform: 'capitalize'
            },
            '& .MuiIconButton-root': {
                padding: '0px 5px',
                borderRadius: '0%',
                '&:hover': {
                    backgroundColor: 'transparent'
                }
            }
        },
        exportButton: {
            textDecoration: 'none',
            fontSize: '0.4rem',
            '&:hover': {
                textDecoration: 'none'
            },
            '&:link': {
                textDecoration: 'none'
            }
        },
        exportIcon: {
            fontSize: '20px',
            fill: 'white'
        }
    })
);

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})((props: MenuProps) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));

const StyledMenuItem = withStyles(theme => ({
    root: {
        '&:focus': {
            backgroundColor: theme.palette.primary.main,
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
            },
        },
    },
}))(MenuItem);

const OrderRawDataView: React.StatelessComponent<OrderRawDataViewProps> = (props) => {
    const [state] = React.useState<TableState>({
        columns: [
            {
                title: 'Order No',
                field: 'orderno',
                filtering: false,
                cellStyle: {
                    padding: '5px 10px',
                    fontSize: '12px'
                },
            },
            // {
            //     title: 'Booking ID',
            //     field: 'refno',
            //     filtering: false,
            //     cellStyle: {
            //         padding: '5px 10px',
            //         fontSize: '12px'
            //     }
            // },
            {
                title: 'Received on',
                field: 'casein_ordercreateddatetime',
                filtering: false,
                cellStyle: {
                    padding: '5px 10px',
                    fontSize: '12px'
                },
            },
            {
                title: 'File Name',
                field: 'fname',
                filtering: false,
                cellStyle: {
                    padding: '5px 10px',
                    fontSize: '12px'
                },
            },
            {
                title: 'Software',
                field: 'software',
                filtering: false,
                cellStyle: {
                    padding: '5px 10px',
                    fontSize: '12px'
                },
            },
            {
                title: 'Destination',
                field: 'destination',
                filtering: false,
                cellStyle: {
                    padding: '5px 10px',
                    fontSize: '12px'
                },
            },
            {
                title: 'Status',
                field: 'customerstatus',
                filtering: false,
                cellStyle: {
                    padding: '5px 10px',
                    fontSize: '12px'
                },
            },
            {
                title: 'Case Type',
                field: 'casetype',
                filtering: false,
                cellStyle: {
                    padding: '5px 10px',
                    fontSize: '12px'
                },
            },
            {
                title: 'Hold',
                field: 'hold',
                filtering: false,
                cellStyle: {
                    padding: '5px 10px',
                    fontSize: '12px'
                },
            },
            {
                title: 'Design Completed',
                field: 'qcout_designcompleted',
                filtering: false,
                cellStyle: {
                    padding: '5px 10px',
                    fontSize: '12px'
                },
            },
            {
                title: 'Units',
                field: 'units',
                filtering: false,
                cellStyle: {
                    padding: '5px 10px',
                    fontSize: '12px'
                },
            },
            {
                title: 'View',
                field: 'orderno',
                export: false,
                render: rowData => (
                    <div style={{ display: 'flex', justifyContent: 'center' }} key={rowData.rowno}>
                        <Tooltip title="View" placement="top">
                            <IconButton aria-label="view" onClick={() => props.onRowClick((JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid))}>
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </div>
                ),
                cellStyle: {
                    padding: '0px',
                    textAlign: 'center'
                }
            }

        ],
        data: []
    });

    const tableHeaders = [
        { label: 'Order No', key: 'orderno' },
        // { label: 'Booking ID', key: 'refno' },
        { label: 'Received on', key: 'casein_ordercreateddatetime' },
        { label: 'File Name', key: 'fname' },
        { label: 'Software', key: 'software' },
        { label: 'Labname', key: 'labname' },
        { label: 'Destination', key: 'destination' },
        { label: 'Status', key: 'customerstatus' },
        { label: 'Case Type', key: 'casetype' },
        { label: 'Hold', key: 'hold' },
        { label: 'Design Completed', key: 'qcout_designcompleted' },
        { label: 'Units', key: 'units' },
    ];

    const [page, setPage] = React.useState(0);
    const [size, setSize] = React.useState(5);
    const [selectedRowsArray, setSelectedRowsArray] = React.useState<RowDataRawOrder[]>([]);

    const handleSelectAll = (tableData: RowDataRawOrder[]) => {
        setSelectedRowsArray(tableData.filter((tableRow) => tableRow.status === '14' || tableRow.status === '10').slice(page * size, (page * size) + size));
    };
    const handleSelectOne = (tableData: RowDataRawOrder) => {

        if (tableData.orderno && (tableData.status === '14' || tableData.status === '10')) {
            setSelectedRowsArray((items: RowDataRawOrder[]) => {
                if (items.find(_d => _d.orderno === tableData.orderno)?.orderno) {
                    return items.filter((item) => item.orderno !== tableData.orderno);
                }
                const newItems = items.concat([tableData]);
                return newItems;
            });
        }

    };

    const [downIndi, setDownIndi] = React.useState(false);
    const downloadFiletypes = ['STL', 'PTS', '3OX'];
    const [openDownload, setOpenDownload] = React.useState(false);
    const [fileTypes, setFileTypes] = React.useState<string[]>([]);
    const [downloadType, setDownloadType] = React.useState('multiple');

    const openDownloadDialog = (rowdata: RowDataRawOrder[] | RowDataRawOrder, type: String) => {
        if (type === 'zip' && selectedRowsArray.length === 1) {
            props.onBulkDownload(selectedRowsArray);
        } else {
            if (type === 'zip') { setDownIndi(true); setDownloadType('multiple'); } else { setDownIndi(false); }
            setFileTypes([]);
            setOpenDownload(true);
        }
    };
    const filetypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            fileTypes.push(event.target.value);
            const tempType = fileTypes.filter((v, i) => fileTypes.indexOf(v) === i);
            setFileTypes(tempType);
        } else {
            setFileTypes(fileTypes.filter((allTypes) => allTypes !== event.target.value));
        }
    };

    const closeDownloadDialog = () => {
        setOpenDownload(false);
    };
    const submitStlDownload = () => {
        setOpenDownload(false);
        props.onBulkDownloadStl(selectedRowsArray, fileTypes.toString());
    };
    const submitZipDownload = () => {
        setOpenDownload(false);
        if (downloadType === 'single') {
            props.onBulkDownload(selectedRowsArray);
        } else {
            props.onBulkDownloadIndividual(selectedRowsArray);
        }
    };

    const [fcaseno, setFcaseno] = React.useState('');
    const [tcaseno, setTcaseno] = React.useState('');
    const [listBy, setListBy] = React.useState(true);
    const [countValidation, setcountValidation] = React.useState(false);

    const maxOrderCount = (fcase: string, tcase: string) => {
        if (Number(parseInt(fcase, 10)) && Number(parseInt(tcase, 10))) {
            const maxCount = Math.abs(parseInt(fcase, 10) - parseInt(tcase, 10));
            if (maxCount < 1000) {
                return false;
            }
        }
        return true;
    };

    const changeFcaseno = (fcase: string) => {
        setFcaseno(fcase);
        props.fDate(new Date());
        props.toDate(new Date());
    };

    const changeTcaseno = (tcase: string) => {
        setcountValidation(false);
        setTcaseno(tcase);
        props.fDate(new Date());
        props.fDate(new Date());
    };

    const handleListBy = (event: React.ChangeEvent<HTMLInputElement>) => {
        setListBy(event.target.checked);
        if (event.target.checked) {
            setFcaseno('');
            setTcaseno('');
        } else {
            props.fDate(new Date());
            props.toDate(new Date());
        }
    };

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const [timezone, setTimezone] = React.useState('IST');

    const handleChangeTimezone = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTimezone(event.target.value);
    };

    const [startDate, setStartDate] = React.useState<Date>(new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000)));
    const [endDate, setEndDate] = React.useState<Date>(new Date());
    const [dayValidation, setDayValidation] = React.useState(false);

    const maxDayCount = (sdate: Date, edate: Date) => {
        if (Math.abs(sdate.getTime() - edate.getTime()) < (8 * 24 * 60 * 60 * 1000)) {
            return false;
        }
        return true;
    };

    const changeStartDate = (date: Date) => {
        setDayValidation(false);
        setStartDate(date);
    };
    const changeEndDate = (date: Date) => {
        setDayValidation(false);
        setEndDate(date);
    };

    // const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    //     setAnchorEl(event.currentTarget);
    // };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const classes = useStyles({});

    const [dialogOpen, setdialogOpen] = React.useState(props.orderrawdata.length > 0 ? false : true);

    const handleClickDialog = () => {
        setdialogOpen(true);
    };

    const handleCloseDialog = () => {
        setdialogOpen(false);
    };

    const submitDialog = () => {
        if (listBy) {

            props.fDate(startDate);
            props.toDate(endDate);

            if (!maxDayCount(startDate, endDate)) {
                setDayValidation(false);
                props.dateFilter('', '', timezone);
                setdialogOpen(false);
            } else {
                setDayValidation(true);
            }

        } else {
            if (fcaseno && tcaseno) {
                if (maxOrderCount(fcaseno, tcaseno)) {
                    setcountValidation(true);
                } else {
                    setcountValidation(false);
                    props.dateFilter(fcaseno, tcaseno, timezone);
                    setdialogOpen(false);
                }
            }
        }
    };
    const resetDialog = () => {
        props.dateReset(timezone);
        setdialogOpen(false);
    };

    const reloadPage = () => {
        if (listBy) {
            props.reload('', '', timezone);
            setdialogOpen(false);
        } else {
            if (fcaseno && tcaseno) {
                if (maxOrderCount(fcaseno, tcaseno)) {
                    setcountValidation(true);
                } else {
                    setcountValidation(false);
                    props.reload(fcaseno, tcaseno, timezone);
                    setdialogOpen(false);
                }
            }
        }
    };
    // Retry Download for file download
    const [selectedFailedFiles, setSelectedFailedFiles] = React.useState<Array<{ fname: string; orderno: string }>>([]);
    const [retryCountMap, setRetryCountMap] = React.useState<Record<string, number>>({});
    
    const handleFailedFileCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, file: { fname: string; orderno: string }) => {
            if (event.target.checked) {
                setSelectedFailedFiles([...selectedFailedFiles, file]);
            } else {
                setSelectedFailedFiles(selectedFailedFiles.filter(item =>
                    !(item.fname === file.fname && item.orderno === file.orderno)
                ));
            }
        };
    
    const handleSelectAllFailedFiles = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            setSelectedFailedFiles([...props.failedFiles]);
        } else {
            setSelectedFailedFiles([]);
        }
    };
    React.useEffect(
        () => {
        if (props.showFailedFilesDialog) {
            // Initialize retry counts for any new files
            const newRetryCountMap = {...retryCountMap};
            props.failedFiles.forEach(file => {
            const fileKey = `${file.orderno}-${file.fname}`;
            if (newRetryCountMap[fileKey] === undefined) {
                newRetryCountMap[fileKey] = 0;
            }
            });
            setRetryCountMap(newRetryCountMap);
            
            // Automatically select all files that haven't exceeded retry limit
            const availableFiles = props.failedFiles.filter(file => {
            const fileKey = `${file.orderno}-${file.fname}`;
            return (newRetryCountMap[fileKey] || 0) < 3;
            });
            
            // Set the selected files
            setSelectedFailedFiles(availableFiles);
        }
        },
        [props.showFailedFilesDialog, props.failedFiles]
    );
    const handleRetryDownload = () => {
        if (selectedFailedFiles.length > 0) {
            // Update retry counts for selected files
            const updatedRetryCountMap = {...retryCountMap};
            selectedFailedFiles.forEach(file => {
                const fileKey = `${file.orderno}-${file.fname}`;
                updatedRetryCountMap[fileKey] = (updatedRetryCountMap[fileKey] || 0) + 1;
            });
            setRetryCountMap(updatedRetryCountMap);
            
            // Create filtered list with only files that haven't exceeded retry limit
            const filesToDownload = props.orderrawdata.filter(item =>
                selectedFailedFiles.some(file => {
                    const fileKey = `${file.orderno}-${file.fname}`;
                    const retryCount = updatedRetryCountMap[fileKey] || 0;
                    return file.fname === item.fname && file.orderno === item.orderno && retryCount <= 3;
                })
            );
            props.closeFailedFilesDialog();

            // if (filesToDownload.length > 0) {
            //     props.onBulkDownloadIndividual(filesToDownload, true);
            // }
            if (filesToDownload.length > 0) {
                if (downloadType === 'single') {
                    props.onBulkDownload(filesToDownload, true); 
                } else {
                    props.onBulkDownloadIndividual(filesToDownload, true); 
                }
            }
        }
    };
    const hasExceededRetryLimit = (file: { fname: string; orderno: string }): boolean => {
        const fileKey = `${file.orderno}-${file.fname}`;
        return (retryCountMap[fileKey] || 0) >= 3;
    };

    // Helper function to get number of retries for a file
    const getRetryCount = (file: { fname: string; orderno: string }): number => {
        const fileKey = `${file.orderno}-${file.fname}`;
        return retryCountMap[fileKey] || 0;
    };
    // const caseCount = props?.failedFiles?.length > 0 ? props.failedFiles[0].caseCount : 0;
    const stfFailedFiles = props.failedFiles.filter(file => file.fileType === 'STL');

    return (
        <div className={classes.root}>
            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} sm={12} md={12}>
                    <div>
                        <Tooltip title="Refresh" placement="top" arrow>
                            <Fab color="primary" aria-label="add" style={{ height: '40px', width: '40px', float: 'left', margin: '12px', zIndex: 100 }} onClick={reloadPage}>
                                <AutorenewIcon />
                            </Fab>
                        </Tooltip>
                        <Tooltip title="Export" placement="top" arrow>
                            <Button
                                id="Export"
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                variant="contained"
                                color="primary"
                                className={classes.buttonSend2}
                            >
                                <CSVLink
                                    data={props.orderrawdataExport}
                                    // enclosingCharacter={``}
                                    headers={tableHeaders}
                                    filename={'Daily Order Report.csv'}
                                    className={classes.exportButton}
                                // target="_blank"
                                >
                                    <FileCopyIcon className={classes.exportIcon} />
                                </CSVLink>
                            </Button>
                        </Tooltip>
                        <Tooltip title="Filter" placement="top" arrow>
                            <Button
                                id="filterDate"
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                variant="contained"
                                color="primary"
                                onClick={handleClickDialog}
                                className={classes.buttonSend2}
                            >
                                <FilterListIcon />
                            </Button>
                        </Tooltip>
                        <Dialog
                            open={dialogOpen}
                            onClose={handleCloseDialog}
                            fullWidth
                            maxWidth="sm"
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title"><Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>Case Filter</Typography></DialogTitle>
                            <DialogContent>
                                <Grid container justify="center" alignItems="center" spacing={2}>
                                    <Grid item>
                                        <Typography component="div">
                                            <Grid component="label" container alignItems="center" spacing={1}>
                                                <Grid item>Case No</Grid>
                                                <Grid item>
                                                    <Switch checked={listBy} onChange={handleListBy} name="listby" color="default" />
                                                </Grid>
                                                <Grid item>Date Range</Grid>
                                            </Grid>
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <br />
                                <Grid container justify="space-around" spacing={2}>
                                    <Grid item xs={12} sm={6} md={5}>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            label="From Case no"
                                            value={fcaseno}
                                            onChange={(event) => changeFcaseno(event.target.value as string)}
                                            disabled={listBy}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={5}>
                                        <TextField
                                            error={countValidation}
                                            helperText={countValidation && 'Total not more than 1000 case numbers'}
                                            fullWidth
                                            variant="outlined"
                                            label="To Case no"
                                            value={tcaseno}
                                            onChange={(event) => changeTcaseno(event.target.value as string)}
                                            disabled={listBy}
                                        />
                                    </Grid>
                                </Grid>
                                <br />
                                <Grid container justify="center" alignItems="center" spacing={2}>
                                    <Grid item>
                                        <div className={classes.modal}>
                                            <Typography variant="body1" style={{ fontWeight: 'bold' }}>- OR -</Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <div className={classes.dialog}>
                                        <Grid container justify="space-around" spacing={2}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="date-picker-dialog"
                                                label="Start Date"
                                                format="MM/dd/yyyy"
                                                value={startDate}
                                                onChange={changeStartDate}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                disabled={!listBy}
                                            />
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="date-picker-dialog-2"
                                                label="End Date"
                                                format="MM/dd/yyyy"
                                                value={endDate}
                                                onChange={changeEndDate}
                                                helperText={dayValidation && 'Data not more than a week'}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                disabled={!listBy}
                                            />
                                        </Grid>
                                    </div>
                                </MuiPickersUtilsProvider>
                                <div>
                                    <Grid container justify="center" spacing={2}>
                                        <FormControl variant="outlined" size="small" className={classes.forms}>
                                            <Select
                                                labelId="timezone-raw-data"
                                                id="timezone-rawdata"
                                                required
                                                onChange={handleChangeTimezone}
                                                value={timezone}
                                            >
                                                <MenuItem value="IST">IST</MenuItem>
                                                <MenuItem value="EST">EST</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </div>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="primary"
                                    className={classes.HeadinG}
                                    onClick={submitDialog}
                                >
                                    Submit
                                </Button>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="secondary"
                                    onClick={resetDialog}
                                    className={classes.HeadinG}
                                >
                                    Reset
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={openDownload}
                            onClose={closeDownloadDialog}
                            aria-labelledby="Dialog-Order-Redesign"
                            fullWidth
                            maxWidth="sm"
                        // maxWidth={!downIndi ? maxWidthDownload : 'md'}
                        >
                            <DialogTitle id="form-dialog-title">{!downIndi ? 'What to download?' : 'Download As'}</DialogTitle>
                            {!downIndi ?
                                <DialogContent dividers>
                                    <Grid container spacing={2}>
                                        {
                                            downloadFiletypes.map((typeFile, indexRe1) => (
                                                <Grid item key={indexRe1} xs={6} sm={4} md={4}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                id={`filetype${indexRe1}`}
                                                                checked={fileTypes.indexOf(typeFile) > -1}
                                                                value={typeFile}
                                                                onChange={filetypeChange}
                                                                name="Filetype"
                                                            />
                                                        }
                                                        label={typeFile}
                                                    />
                                                </Grid>
                                            ))
                                        }
                                    </Grid>
                                </DialogContent>
                                : <DialogContent dividers>
                                    <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <RadioGroup aria-label="down-type" name="download-type" value={downloadType} onChange={(e) => setDownloadType(e.target.value)}>
                                            {/* <FormControlLabel value="single" control={<Radio color="secondary" />} label="Single Compressed File" /> */}
                                           {selectedRowsArray && selectedRowsArray.length <= 10 && ( 
                                                <FormControlLabel value="single" control={<Radio color="secondary" />} label="Single Compressed File" /> 
                                            )}
                                            <FormControlLabel value="multiple" control={<Radio color="secondary" />} label="Individual Files" />
                                        </RadioGroup>
                                    </Grid> 
                                    {selectedRowsArray && selectedRowsArray.length > 0 && (
                                    <Grid item xs={12}>
                                    <Box 
                                        p={2} 
                                        mt={1}
                                        border={1} 
                                        borderColor="divider" 
                                        borderRadius="borderRadius" 
                                        bgcolor="background.paper"
                                    >
                                        <Typography variant="subtitle2" gutterBottom>
                                        Selected Files: {selectedRowsArray.length}
                                        </Typography>
                                        
                                        {/* <Typography variant="body2" color="textSecondary">
                                        Total Size: {calculateTotalFileSize(selectedRowsArray)}
                                        </Typography> */}
                                        {selectedRowsArray.length <= 5 ? (
                                        <Typography variant="body2" color="textSecondary">
                                            Estimated download time: 3 - 5 Mins (approx)
                                        </Typography>
                                        ) : selectedRowsArray.length > 5 && selectedRowsArray.length <= 25 ? (
                                        <Typography variant="body2" color="textSecondary">
                                            Estimated download time: 8 - 10 Mins (approx)
                                        </Typography>
                                        ) : selectedRowsArray.length > 25 && selectedRowsArray.length <= 50 ? (
                                        <Typography variant="body2" color="textSecondary">
                                            Estimated download time: 15 - 18 Mins (approx)
                                        </Typography>
                                        ) : (
                                        <Typography variant="body2" color="textSecondary">
                                            Estimated download time: 20 - 25 Mins (approx)
                                        </Typography>
                                        )}
                                    </Box>
                                    </Grid>
                                )}   
                                    </Grid>
                                </DialogContent>

                            }
                            <DialogActions>
                                {downloadType === 'single' && downIndi && <Typography variant="caption" >
                                    *Note: If selected file size exceeding 1 GB might not download properly, consider downloading as Individual files.
                                </Typography>}
                                <Button size="small" onClick={closeDownloadDialog} color="secondary">
                                    Cancel
                                </Button>
                                {!downIndi && <Button size="small" onClick={submitStlDownload} color="primary">
                                    Download
                                </Button>}
                                {downIndi && <Button size="small" onClick={() => submitZipDownload()} color="primary">
                                    OK
                                </Button>}
                            </DialogActions>
                        </Dialog>
                        {props.isDownloading === true ? <CircularProgress className={classes.buttonSend} /> : null}
                        <StyledMenu
                            id="customized-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <StyledMenuItem key="1">
                                <ListItemIcon>
                                    <PictureAsPdfIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary="PDF" />
                            </StyledMenuItem>
                            <StyledMenuItem key="2">
                                <ListItemIcon>
                                    <InsertDriveFileIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary="CSV" />
                            </StyledMenuItem>
                            <StyledMenuItem key="3">
                                <ListItemIcon>
                                    <AssignmentIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary="EXCEL" />
                            </StyledMenuItem>
                        </StyledMenu>
                    </div>
                    <Dialog
                        // open={props.showFailedFilesDialog && props.failedFiles.length > 0}
                        open={props.showFailedFilesDialog && props.failedFiles.length > 0 && stfFailedFiles.length === 0}
                        onClose={props.closeFailedFilesDialog}
                        aria-labelledby="failed-files-dialog-title"
                        fullWidth
                        maxWidth="sm"
                    >
                        <DialogTitle id="failed-files-dialog-title">
                            <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                Failed Downloads
                            </Typography>
                        </DialogTitle>
                        <DialogContent dividers>
                            {props.failedFiles && props.failedFiles.length > 0 && (
                                <div className={classes.failedFilesContainer}>
                                    <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={selectedFailedFiles.length === props.failedFiles.length}
                                                    onChange={handleSelectAllFailedFiles}
                                                    color="primary"
                                                />
                                            }
                                            label="Select All"
                                        />
                                        <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: 'red' }}>
                                            Total: {props.failedFiles?.length}
                                        </Typography>
                                    </Box>
                                    <TableContainer component={Paper} className={classes.tableContainer}>
                                        <Table aria-label="failed files table" size="small">
                                            <TableHead style={{ backgroundColor: '#bdbdbd', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                <TableRow>
                                                    <TableCell padding="checkbox">Select</TableCell>
                                                    <TableCell>S.No</TableCell>
                                                    <TableCell>Order No</TableCell>
                                                    <TableCell>File Name</TableCell>
                                                    <TableCell>Retry Count</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {props.failedFiles.map((file, index) => {
                                                    const exceededLimit = hasExceededRetryLimit(file);
                                                    const retryCount = getRetryCount(file);

                                                    return (
                                                        <TableRow key={index}>
                                                            <TableCell padding="checkbox">
                                                                <Checkbox
                                                                    checked={selectedFailedFiles.some(item => item.fname === file.fname && item.orderno === file.orderno)}
                                                                    onChange={(event) => handleFailedFileCheckboxChange(event, file)}
                                                                    color="primary"
                                                                    disabled={exceededLimit}
                                                                />
                                                            </TableCell>
                                                            <TableCell>{index + 1}</TableCell>
                                                            <TableCell>{file.orderno}</TableCell>
                                                            <TableCell>{file.fname}</TableCell>
                                                            <TableCell>
                                                                {retryCount}/3
                                                                {exceededLimit && (
                                                                    <Typography variant="caption" style={{ color: 'red', display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                        Max retries exceeded
                                                                    </Typography>
                                                                )}
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={handleRetryDownload}
                                style={{
                                    backgroundColor: selectedFailedFiles.some(file => !hasExceededRetryLimit(file))
                                        ? '#1976d2' : '#f44336',
                                    color: 'white'
                                }}
                                variant="contained"
                                disabled={selectedFailedFiles.length === 0 || selectedFailedFiles.every(file => hasExceededRetryLimit(file))}
                            >
                                Retry Download
                            </Button>
                            <Button onClick={props.closeFailedFilesDialog} color="primary" variant="contained">
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={props.showFailedFilesDialog && stfFailedFiles.length > 0}  // Show dialog only if there are STL files
                        onClose={props.closeFailedFilesDialog}
                        aria-labelledby="failed-files-dialog-title"
                        fullWidth
                        maxWidth="sm"
                    >
                        <DialogTitle id="failed-files-dialog-title">
                            <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                STL Files - Failed Downloads
                            </Typography>
                        </DialogTitle>
                        <DialogContent dividers>
                            {stfFailedFiles && stfFailedFiles.length > 0 && (
                                <div className={classes.failedFilesContainer}>
                                
                                    <Box 
                                            style={{ 
                                                border: '1px solid #e0e0e0', 
                                                borderRadius: '4px', 
                                                padding: '12px', 
                                                marginBottom: '8px' 
                                            }}
                                    >
                                            <Box style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
                                                <Typography variant="subtitle1" color="textSecondary">
                                                    {/* STL files available for: {caseCount ?? 0} orders */}
                                                    Below files are not available. Please contact support team
                                                </Typography>
                                                {/* <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                                                    Total: {stfFailedFiles.length}
                                                </Typography> */}
                                            </Box>
                                            
                                            {/* <Typography variant="subtitle1" color="textSecondary">
                                                STL files not available for: {selectedRowsArray.length - (caseCount ?? 0)} orders
                                            </Typography> */}
                                    </Box>
                                    <TableContainer component={Paper} className={classes.tableContainer}>
                                        <Table aria-label="failed files table" size="small">
                                            <TableHead style={{ backgroundColor: '#bdbdbd', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                <TableRow>
                                                    <TableCell>S.No</TableCell>
                                                    <TableCell>Order No</TableCell>
                                                    <TableCell>File Name</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {stfFailedFiles.map((file, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{index + 1}</TableCell>
                                                        <TableCell>{file.orderno}</TableCell>
                                                        <TableCell>{file.fname}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={props.closeFailedFilesDialog} color="primary" variant="contained">
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <MaterialTable
                        icons={tableIcons}
                        title="Daily Order Report"
                        columns={state.columns}
                        data={props.orderrawdata}
                        localization={{
                            toolbar: {
                                nRowsSelected: `${selectedRowsArray.length} order(s) selected`,
                                exportTitle: 'Export as Excel'
                            },
                            header: {
                                actions: ''
                            },
                            body: {
                                emptyDataSourceMessage: 'No orders to display'
                            }
                        }}
                        components={{
                            Toolbar: some => (
                                <div className={classes.mtable}>
                                    <MTableToolbar {...some} />
                                </div>
                            )
                        }}
                        options={{
                            // filtering: true,
                            pageSizeOptions: [5, 10, 25, 50, 100],
                            actionsColumnIndex: -1,
                            headerStyle: {
                                backgroundColor: '#757575',
                                color: '#fff',
                                padding: '10px',
                                textAlign: 'center'
                            },
                            rowStyle: {
                                padding: '0px 0px'
                            },
                            selection: true,
                            sorting: false,
                            selectionProps: (selecrowData: RowDataRawOrder) => {                                
                                const checked = (selecrowData.status !== '14' && selecrowData.status !== '10') ? { checked: false } : {};
                                const check = (selectedRowsArray.find(_d => _d.orderno === selecrowData.orderno)?.orderno) ? { checked: true } : { checked: false };
                                return {
                                    disabled: (selecrowData.status !== '14' && selecrowData.status !== '10'),
                                    ...checked,
                                    ...check
                                };
                            }
                            // exportButton: true,
                            // exportAllData: true,
                        }}
                        onSelectionChange={
                            (rows, rowData) => {
                                if (!rowData) {
                                    handleSelectAll(rows);
                                } else {
                                    handleSelectOne(rowData);
                                }
                            }
                        }
                        onChangePage={
                            (pageno) => {
                                setPage(pageno);
                            }
                        }
                        onChangeRowsPerPage={
                            (pageSize) => {
                                if (pageSize !== size) {
                                    if (pageSize > size) {
                                        setPage(prev => Math.min((Math.max((prev * pageSize) - pageSize, props.orderrawdata.length / 5), 0)));
                                    } else {
                                        setPage(prev => Math.min((Math.max((prev * pageSize) + pageSize, props.orderrawdata.length / 5), 0)));
                                    }
                                }
                                setSize(pageSize);
                            }
                        }
                        actions={[
                            {
                                icon: () => (
                                    (!props.isDownloading ?
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<CloudDownloadIcon />}
                                        >
                                            Download Zip
                                        </Button>
                                        :
                                        <>
                                        </>
                                    )),
                                tooltip: 'Download zip files',
                                isFreeAction: false,
                                onClick: (event, rowdata) => {

                                    if (!props.isDownloading) {
                                        openDownloadDialog(rowdata, 'zip');
                                    }
                                }
                            },
                            {
                                icon: () => (
                                    (!props.isDownloading ?
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<CloudDownloadIcon />}
                                        >
                                            Download STL/PTS/3OX
                                        </Button>
                                        :
                                        <>
                                        </>
                                    )),
                                tooltip: 'Download STL/PTS/3OX files',
                                isFreeAction: false,
                                onClick: (event, rowdata) => {

                                    if (!props.isDownloading) {
                                        openDownloadDialog(rowdata, 'stl');
                                    }
                                }
                            }
                        ]}
                    />
                </Grid>
            </Grid>
        </div >
    );
};

export default OrderRawDataView;



// WEBPACK FOOTER //
// ./src/components/layouts/OrderRawDataView.tsx